import { AnimatePresence } from 'framer-motion';
import { RealImpact } from './RealImpact';
import { RealResults } from './RealResults';
import { HowOathWorks } from './HowOathWorks';
import { OurAlgorithm } from './OurAlgorithm';
import { ENV_CONFIG } from 'config/environment';
import { ImpactRatings } from './ImpactRatings';
import { Quote } from 'components/LottieElements/Quote';
import { useAppSelector } from 'helpers/hooks';
import HeaderAndFooterLayout from 'layouts/HeaderAndFooter';
import { getImpactConfig } from 'selectors/siteConfig';

export const ImpactScoreScreen = () => {
  const impactRatings = useAppSelector(state => getImpactConfig(state, 'impact_ratings'));

  return (
    <HeaderAndFooterLayout
      footerVisible={true}
      footerShowSupportCta={true}
      headerVisible={true}
      isLoading={false}
      hasIssues={true}
    >
      <AnimatePresence>
        <HowOathWorks />
        <ImpactRatings impactRatings={impactRatings} />
        <OurAlgorithm />
        <RealImpact />
        <RealResults />
        <Quote
          text="“Oath was a particularly important partner in our successful 2024 campaign for Congress. The Nominee Fund provided a critical boost immediately after we won our Primary, and the funds secured at every turn allowed me to spend more time with voters and our coalition on the ground. Oath's support played a critical role in our ability to win in a Trump-won district, and I am very grateful.“"
          name="Kristen McDonald Rivet"
          role="Michigan's 8th District, U.S. House"
          image={`${ENV_CONFIG().CLOUD_STORAGE.URL}/recipients/rec_2124.jpg`}
        />
      </AnimatePresence>
    </HeaderAndFooterLayout>
  );
};
